import React from "react";
import Footer from "../../components/Footer";
import HolidayForm from "../../components/forms/Communicate/Holiday"
import NavBar from "../../components/navbar-components/NavBar";

const Holiday = () => {
    return (
        <>
        <NavBar/>
        <div className="bg-gray-200 py-5">
            <HolidayForm/>
        </div>
        <Footer/>
        </>
    )
}

export default Holiday